import { firstValueFrom } from "rxjs";
import { processBatchGetDataService } from "./services";
import { BatchData, ObjRequest, RequestItem } from "./corpo.model";
import { FormatType } from "./enumType";

const requestQueue: RequestItem[] = [];
export function pushQueue(url: string, Issuer: string, Metric: string, Year: number, format: FormatType = null, invocation: CustomFunctions.Invocation) :Promise<BatchData> {

    return new Promise<BatchData>((resolve, reject) => {
        requestQueue.push(
            {
                Issuer,
                Metric,
                Year,
                resolve,
                reject
            }
        );
        startBatch(url,format,invocation);
    });
}



let batchTimer: any = null;
const time = 100;
function startBatch(url: string, format: FormatType, invocation: CustomFunctions.Invocation) {

    if (batchTimer) return;

    batchTimer = setTimeout(() => {
        processBatch(url,format, invocation);
        batchTimer = null;
    }, time);
}


function processBatch(url: string,format: FormatType, invocation: CustomFunctions.Invocation) {
    const batch = [...requestQueue];
    requestQueue.length = 0;
    let payloadByIssuer: ObjRequest[] = [];

    const grouped = new Map<string, { metricName: string; year: number; resolve: Function; reject: Function }[]>();

    for (const req of batch) {
        if (!grouped.has(req.Issuer)){
            grouped.set(req.Issuer, []);
        }
        grouped.get(req.Issuer)!.push({ metricName: req.Metric, year: req.Year, resolve: req.resolve, reject: req.reject });
    }

    grouped.forEach((queries, issuerName) => {
        //queries = queries.filter(q => (q.metricName && q.metricName.trim().length > 0 ) && (q.year && q.year > 0))
        const request = {
            issuerName,
            queryData: queries.map(q => (
                { 
                    metricName: q.metricName, 
                    year: q.year 
                }
            ))
        }
        payloadByIssuer.push(request);

    });

    paralyzeProcessBatch(payloadByIssuer, url, batch, invocation);

}

const N = 4;
async function paralyzeProcessBatch(payloadByIssuer: ObjRequest[], url: string, requestItems: RequestItem[], invocation: CustomFunctions.Invocation) {

    const chunks = [];

    for (let i = 0; i < payloadByIssuer.length; i += N) {
        chunks.push(payloadByIssuer.slice(i, i + N));
    }

    for (const chunk of chunks) {

        await Promise.all(
            chunk.map(async req => {

                const filtReqItems = requestItems.filter(
                    r => r.Issuer === req.issuerName
                );

                try {
                    await firstValueFrom(
                        processBatchGetDataService(url, req, filtReqItems, invocation),
                        { defaultValue: null }
                    );
                } catch {
                    console.error("paralyze batch error");
                }

            })
        );

    }
}